import { useStore } from '~/app/store'
import { SVGLogout } from '~/shared/ui'

interface handleLogoutProps {
  title?: string
}

export const LogoutButton = ({ title }: handleLogoutProps) => {
  const { authStore } = useStore()

  const handleLogout = () => {
    authStore.logout()
  }

  return (
    <div onClick={handleLogout} className="flex gap-2 cursor-pointer">
      {title}
      <SVGLogout />
    </div>
  )
}
